import script from "./SelectCargoTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCargoTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectCargoTemplateModal.vue?vue&type=style&index=0&id=bea97724&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bea97724"]])

export default __exports__